<template>
  <div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-info">
      <b-row>
        <b-col xl="3" md="6">
          <stats-card type="gradient-info" icon="ni ni-chart-bar-32" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">
              TOTAL ALUMNI
            </h5>
            <span class="h2 font-weight-bold mb-0">{{ totalAlumni }}</span>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card type="gradient-info" icon="ni ni-chart-bar-32" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">
              TOTAL BELUM MENGISI
            </h5>
            <span class="h2 font-weight-bold mb-0">{{ totalBelumMengisi }}</span>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <!--Tables-->
            <b-row class="mt-2">
              <b-col xl="12" class="mb-5 mb-xl-0">
                <b-card body-class="p-0" header-class="border-0">
                  <template v-slot:header>
                    <b-row align-v="center">
                      <b-col>
                        <h3 class="mb-0">Data Alumni</h3>
                      </b-col>
                      <!-- <b-col class="text-right">
                        <a href="#!" class="btn btn-sm btn-primary"><i class="ni ni-fat-add"></i>Tambah Data</a>
                      </b-col> -->
                    </b-row>
                  </template>

                  <div class="padding">
                    <div v-show="loading">
                      <Loading />
                    </div>
                    <b-col class="text-right">
                      <button @click="downloadFile()" class="btn btn-sm btn-default">
                        <i class="fa fa-download mr-2"></i>Download Data
                      </button>
                      <button class="btn btn-sm btn-info" v-b-modal.modal-prevent-filter>
                        <i class="fa fa-filter mr-2"></i>Filter Data
                      </button>
                      <!-- <select name="study_program" @change="getAlumni" class="text-left" v-model="selected">
                        <option value="" disabled>Pilih Tahun Lulusan</option>
                        <option v-for="tahun_lulusan in list_tahun_lulusan" :key="tahun_lulusan.tahun"
                          :value="tahun_lulusan.tahun">
                          {{ tahun_lulusan.tahun }}
                        </option>
                      </select> -->
                    </b-col>
                    <v-client-table :data="tableData" :columns="columns" :options="options">
                      <template slot="status_mengisi" slot-scope="{ row }">
                        <button v-if="row.status_mengisi == 1" class="btn btn-sm btn-success">
                          sudah
                        </button>
                        <button v-if="row.status_mengisi == 0" class="btn btn-sm btn-danger">
                          belum
                        </button>
                      </template>
                      <!-- <template slot="actions" slot-scope="{ row }">
                        <router-link :to="{name: 'edit-alumni', params: { id: row.id }}" class="btn btn-sm btn-info"><i
                            class="ni ni-curved-next"></i></router-link>
                        <button @click="del(row.id, row.index, $event.target)" class="btn btn-sm btn-danger"><i
                            class="ni ni-fat-remove"></i></button>
                      </template> -->
                    </v-client-table>
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <!--End tables-->
          </card>
        </b-col>
      </b-row>
    </b-container>
              <!-- modal filer-->
      <b-modal class="b-modal.modal-lg" id="modal-prevent-filter" ref="modal" title="Filter Data Alumni">
      <div v-show="loading">
          <Loading/>
      </div>
      <form>
          <div class="row">
              <div class="col-12">
                  <label>Filter Tahun</label>
                  <select
                      name="id_tahun"
                      class="form-control border text-left mr-2"
                      v-model="selected_id_tahun">
                      <option value="" disabled="disabled">Pilih Filter Tahun</option>
                      <option value="1">Lulusan/Kompre</option>
                      <option value="2">Wisuda</option>
                  </select>
              </div>
          </div>
          <div
              v-if="errors.has('id_tahun')"
              class="alert alert-danger rounded mb-3"
              role="alert">
              Tahun Wajib diisi!
          </div>
          <div class="row mt-3" v-if="this.selected_id_tahun == 1 || this.selected_id_tahun == 2">
              <div class="col-12">
                  <label>Tahun</label>
                <select
                    name="study_program"
                    @change="getAlumni"
                    class="form-control border text-left"
                    v-model="selected_tahun">
                    <option value="" disabled="disabled">Pilih Tahun Lulusan</option>
                    <option
                        v-for="tahun_lulusan in list_tahun_lulusan"
                        :key="tahun_lulusan.tahun"
                        :value="tahun_lulusan.tahun">
                        {{ tahun_lulusan.tahun }}
                    </option>
                </select>
              </div>
          </div>
          <div
              v-if="errors.has('tahun')"
              class="alert alert-danger rounded mb-3"
              role="alert">
              Tahun Wajib diisi!
          </div>

      </form>
      </b-modal>
      <!-- end-modal filter-->
  </div>
</template>

<script>
import BaseHeader from "@/components/admin/BaseHeader";
import DataService from "@/services/data.service";
import Loading from "@/components/Loading.vue";

export default {
  name: "Alumni",
  components: {
    BaseHeader,
    Loading
  },
  data() {
    return {
      selected_id_tahun: "",
      selected_tahun: "",
      list_tahun_lulusan: {},
      totalAlumni: "",
      totalBelumMengisi: "",
      loading: false,
      columns: [
        "username",
        "nama_lengkap",
        "tgl_lahir",
        "nm_fakultas",
        "nm_program_studi",
        "angkatan",
        "tanggal_lulus",
        "tanggal_wisuda",
        "ipk",
        "tlpn_hp",
        "status_mengisi"
      ],
      tableData: [],
      options: {
        perPage: 100,
        perPageValues: [],
        headings: {
          username: "NPM",
          nama_lengkap: "Nama Lengkap",
          tgl_lahir: "Tgl Lahir",
          nm_fakultas: "Fakultas",
          nm_program_studi: "Program Studi",
          angkatan: "Angkatan",
          tanggal_lulus: "Tgl Lulus",
          tanggal_wisuda: "Tgl Wisuda",
          ipk: "IPK",
          tlpn_hp: "Telepon",
          status_mengisi: "Status"
        },
        sortable: ["username", "nama_lengkap", "tgl_lahir", "angkatan", "tanggal_lulus", "tanggal_wisuda", "ipk"],
        filterable: ["username", "nama_lengkap", "tlpn_hp"],
        texts: {
          count: "Menampilkan {from}–{to} dari {count} data",
          first: "«",
          last: "»",
          filter: "",
          filterPlaceholder: "Cari NPM / Nama / Telp...",
          limit: false,
          page: "Page:",
          noResults: "Data tidak ditemukan",
          loading: "Memuat...",
          defaultOption: "Select {column}",
          columns: "Columns"
        },
        sortIcon: {
          is: "fa fa-sort",
          base: "font-awesome",
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          align: "center"
        },
        pagination: {
          show: true,
          dropdown: false,
          chunk: 5,
          edge: false,
          align: "right",
          nav: "scroll"
        }
      }
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    var self = this;
    self.loading = true;
    self.$store.commit("SHOW_LOADING", "Memuat data alumni prodi...");
    DataService.getKaprodiAlumniChoise(this.currentUser.user.username).then(
      res => {
        self.tableData = res.data.alumni;
        self.totalAlumni = res.data.totalAlumni;
        self.totalBelumMengisi = res.data.totalBelumMengisi;
        self.loading = false;
        self.$store.commit("HIDE_LOADING");
      }
    ).catch(() => {
      self.loading = false;
      self.$store.commit("HIDE_LOADING");
    });

    DataService.getTahunLulusan(this.currentUser.user.username)
      .then(res => {
        self.list_tahun_lulusan = res.data.tahunLulusan;
        // Auto-select tahun saat ini - 1 jika ada di list
        var defaultTahun = new Date().getFullYear() - 1;
        var found = (self.list_tahun_lulusan || []).find(function (t) { return t.tahun == defaultTahun; });
        if (found && !self.selected_tahun) {
          self.selected_id_tahun = "1";
          self.selected_tahun = defaultTahun;
        }
      })
      .catch(error => console.error(error));
  },

  methods: {
    downloadFile() {
      var self = this;
      if (!self.selected_tahun) {
        self.$swal({ icon: "error", title: "Pilih tahun dulu" });
        return;
      }
      self.loading = true;
      self.$store.commit("SHOW_LOADING", "Menyiapkan file Excel data alumni...");
      DataService.downloadFileAlumniKaprodi(self.selected_id_tahun, self.selected_tahun, self.currentUser.user.username)
        .then(res => {
          self.customDownload(res, "DataAlumni_" + self.selected_tahun);
          self.loading = false;
          self.$store.commit("HIDE_LOADING");
        })
        .catch(error => {
          self.loading = false;
          self.$store.commit("HIDE_LOADING");
          self.$swal({ icon: "error", title: "Gagal mengunduh" });
        });
    },
    customDownload(res, filename) {
      var newBlob = new Blob([res.data], {
        type: "application/xlsx"
      });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download = filename + ".xlsx";
      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    getAlumni() {
      var self = this;
      self.loading = true;
      self.$store.commit("SHOW_LOADING", "Memuat data alumni...");
      DataService.getFilterAlumniChoise(
          self.selected_id_tahun,
          self.selected_tahun,
          self.currentUser.user.username
        )
        .then(res => {
          self.tableData = res.data.alumni;
          self.totalAlumni = res.data.totalAlumni;
          self.totalBelumMengisi = res.data.totalBelumMengisi;
          self.loading = false;
          self.$store.commit("HIDE_LOADING");
          self.$nextTick(() => self.$bvModal.hide("modal-prevent-filter"));
        })
        .catch(() => {
          self.loading = false;
          self.$store.commit("HIDE_LOADING");
        });
    }
  }
};
</script>
<style scoped>
.padding {
  padding: 20px !important;
}

/* Hide v-client-table default 10/25/50/100 limit dropdown (mengganggu UX) */
::v-deep .VueTables__limit-field,
::v-deep .VueTables__limit,
::v-deep .row.VueTables__limit-row,
::v-deep .VueTables__limit-row {
  display: none !important;
}

/* Polish pagination (Argon style consistent dgn admin Alumni) */
::v-deep .VuePagination {
  padding: 10px 0;
}
::v-deep .VuePagination .page-link {
  border-radius: 6px;
  margin: 0 2px;
  border: 1px solid #e9ecef;
  color: #525f7f;
  font-weight: 500;
  min-width: 32px;
  text-align: center;
}
::v-deep .VuePagination .page-item.active .page-link {
  background-color: #5e72e4;
  border-color: #5e72e4;
  color: #fff;
}
::v-deep .VueTables__search-field input {
  border-radius: 6px;
  border: 1px solid #e9ecef;
  padding: 0.4rem 0.75rem;
  font-size: 0.875rem;
}
</style>
